'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrencyConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrencyConstants = exports.CurrencyConstants = (0, _keymirror2.default)({
    LOAD_DATA: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/currency.js
// module id = 1869
// module chunks = 0